import React from 'react';
import { motion } from 'framer-motion';
// Pre-generated particle positions for a stable, performant field
const particles = Array.from({
  length: 28
}, (_, i) => ({
  id: i,
  left: `${i * 37 % 100}%`,
  size: 2 + i % 3,
  delay: i * 0.4 % 8,
  duration: 14 + i % 6 * 2,
  opacity: 0.15 + i % 4 * 0.1
}));
export function BackgroundFX() {
  return <div aria-hidden="true" className="fixed inset-0 pointer-events-none z-0 overflow-hidden" data-id="element-10">
      {/* Liquid Blob 1 — Top Left */}
      <motion.div className="absolute rounded-full" style={{
      width: '60vw',
      height: '60vw',
      left: '-15vw',
      top: '-10vw',
      background: 'radial-gradient(circle at center, rgba(200,255,0,0.18) 0%, rgba(200,255,0,0.06) 35%, transparent 70%)',
      filter: 'blur(80px)'
    }} animate={{
      x: [0, 60, -20, 0],
      y: [0, -30, 40, 0],
      scale: [1, 1.1, 0.95, 1]
    }} transition={{
      duration: 28,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-11" />

      {/* Liquid Blob 2 — Center Right */}
      <motion.div className="absolute rounded-full" style={{
      width: '50vw',
      height: '50vw',
      right: '-10vw',
      top: '30vh',
      background: 'radial-gradient(circle at center, rgba(200,255,0,0.12) 0%, rgba(200,255,0,0.04) 40%, transparent 70%)',
      filter: 'blur(90px)'
    }} animate={{
      x: [0, -50, 30, 0],
      y: [0, 60, -20, 0],
      scale: [1, 0.9, 1.15, 1]
    }} transition={{
      duration: 34,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-12" />

      {/* Liquid Blob 3 — Bottom Left */}
      <motion.div className="absolute rounded-full" style={{
      width: '55vw',
      height: '55vw',
      left: '-5vw',
      bottom: '-15vw',
      background: 'radial-gradient(circle at center, rgba(200,255,0,0.14) 0%, rgba(200,255,0,0.05) 35%, transparent 70%)',
      filter: 'blur(100px)'
    }} animate={{
      x: [0, 40, -30, 0],
      y: [0, -50, 20, 0],
      scale: [1, 1.05, 0.9, 1]
    }} transition={{
      duration: 31,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-13" />

      {/* Liquid Blob 4 — Top Center (smaller, brighter) */}
      <motion.div className="absolute rounded-full" style={{
      width: '30vw',
      height: '30vw',
      left: '40vw',
      top: '5vh',
      background: 'radial-gradient(circle at center, rgba(200,255,0,0.10) 0%, rgba(200,255,0,0.03) 40%, transparent 70%)',
      filter: 'blur(70px)'
    }} animate={{
      x: [0, -20, 30, 0],
      y: [0, 40, -10, 0],
      scale: [1, 1.2, 0.85, 1]
    }} transition={{
      duration: 24,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-14" />

      {/* Floating Lime Particles */}
      <div className="absolute inset-0" data-id="element-15">
        {particles.map(p => <motion.div key={p.id} className="absolute rounded-full" style={{
        left: p.left,
        bottom: '-10px',
        width: `${p.size}px`,
        height: `${p.size}px`,
        background: '#C8FF00',
        boxShadow: '0 0 8px rgba(200,255,0,0.6), 0 0 16px rgba(200,255,0,0.3)',
        opacity: p.opacity
      }} animate={{
        y: ['0vh', '-110vh'],
        x: [0, (p.id % 2 === 0 ? 1 : -1) * (20 + p.id % 30)],
        opacity: [0, p.opacity, p.opacity, 0]
      }} transition={{
        duration: p.duration,
        delay: p.delay,
        repeat: Infinity,
        ease: 'linear',
        times: [0, 0.1, 0.85, 1]
      }} data-id="element-16" />)}
      </div>

      {/* Subtle Noise/Grain Overlay for Liquid Texture */}
      <div className="absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} data-id="element-17" />
    </div>;
}